meedy.factory('referralToClinicService', ['$q', 'baseService', 'objectHelper', 'config', '$sce',
    function ($q, baseService, objectHelper, config, $sce) {

        function ReferralToClinicService() {

            this.save = function (data) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/clinic-referrals', data).then(
                    function (successResponse) {
                        d.resolve(successResponse);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getPDF = function (id) {
                var d = $q.defer();

                var options = {
                    responseType: 'arraybuffer'
                };

                baseService.get(config.API_URL + '/clinic-referrals/' + id + '/pdf/download', options).then(
                    function (successResponse) {
                        var file = new Blob([successResponse], { type: 'application/pdf' });
                        var fileURL = URL.createObjectURL(file);
                        var link = $sce.trustAsResourceUrl(fileURL);

                        d.resolve(link);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.delete = function (id) {
                var d = $q.defer();

                baseService.delete(config.API_URL + '/clinic-referrals/' + id).then(
                    function (successResponse) {
                        d.resolve(successResponse);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

        }

        return new ReferralToClinicService();
    }
]);
